import {useEffect} from 'react';
import {useCookies} from 'react-cookie';

import {cookieDomain, AFFID_COOKIE_NAME, hasSecureCookie} from './constants';

const useHandleAffid = (contentfulAffid?: string): void => {
  const [cookies, setCookie] = useCookies();

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const overrideParam = urlSearchParams.get('override');
    const affidParam = urlSearchParams.get('affid');

    const setAffid = (affidToSet: string) => {
      window.AFFID = affidToSet;
      setCookie(AFFID_COOKIE_NAME, affidToSet, {
        maxAge: 24 * 60 * 60,
        path: '/',
        domain: cookieDomain,
        secure: hasSecureCookie,
      });
    };

    if (overrideParam === 'true' && affidParam) {
      setAffid(affidParam);
      return;
    }

    const idToSet = contentfulAffid || affidParam;
    if (idToSet && !cookies.affid) {
      setAffid(idToSet);
    } else if (cookies.affid) {
      window.AFFID = cookies.affid;
    }
  }, []);
};

export default useHandleAffid;
